import {makeAutoObservable} from "mobx";

export default class CertStore {
    constructor() {
        this._pem = ''
        this._crt = ''
        this._key = ''
        makeAutoObservable(this);
    }

    setPem(newPem) {
        this._pem = newPem
    }
    setCrt(newCrt) {
        this._crt = newCrt
    }
    setKey(newKey) {
        this._key = newKey
    }

    get pem() {
        return this._pem
    }

    get crt() {
        return this._crt
    }
    get key() {
        return this._key
    }
}